module.exports = __webpack_public_path__ + "static/media/Pisa.311fc14d.png";